import React, { useMemo } from 'react'
import { BellOutlined, ExclamationCircleOutlined, EnvironmentOutlined, ToolOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Badge, Dropdown, Button } from 'antd'
import useNotifications from './useNotifications'
import './notificationBell.scss'

const TYPE_CONFIG = {
  alert:      { icon: <ExclamationCircleOutlined />, avatarClass: 'notification-item__avatar--alert' },
  geofence:   { icon: <EnvironmentOutlined />,        avatarClass: 'notification-item__avatar--geofence' },
  maintenance:{ icon: <ToolOutlined />,              avatarClass: 'notification-item__avatar--maintenance' },
  info:       { icon: <InfoCircleOutlined />,         avatarClass: 'notification-item__avatar--info' },
}

const getRelativeTime = (timestamp) => {
  const diff = Date.now() - timestamp
  const minutes = Math.floor(diff / 60000)
  if (minutes < 1) return 'À l\'instant'
  if (minutes < 60) return `il y a ${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `il y a ${hours}h`
  const days = Math.floor(hours / 24)
  if (days === 1) return 'Hier'
  return `il y a ${days} jours`
}

const NotificationBell = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications()

  const sortedNotifications = useMemo(
    () => [...notifications].sort((a, b) => b.time - a.time),
    [notifications]
  )

  const panelContent = (
    <div className="notification-panel">
      <div className="notification-panel__header">
        <h4 className="notification-panel__title">Notifications</h4>
        {unreadCount > 0 && (
          <Button
            type="link"
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              markAllAsRead()
            }}
            style={{ color: '#13AED8', fontSize: 12, padding: 0, height: 'auto' }}
          >
            Tout marquer comme lu
          </Button>
        )}
      </div>

      {sortedNotifications.length === 0 ? (
        <div className="notification-panel__empty">
          <BellOutlined />
          <span>Aucune notification</span>
        </div>
      ) : (
        <div className="notification-panel__list">
          {sortedNotifications.map((notif) => {
            const config = TYPE_CONFIG[notif.type] || TYPE_CONFIG.info
            return (
              <div
                key={notif.id}
                className={`notification-item ${notif.read ? 'notification-item--read' : 'notification-item--unread'}`}
                onClick={() => !notif.read && markAsRead(notif.id)}
              >
                <div className={`notification-item__avatar ${config.avatarClass}`}>
                  {config.icon}
                </div>
                <div className="notification-item__content">
                  <p className="notification-item__title">{notif.title}</p>
                  <p className="notification-item__desc">{notif.description}</p>
                  <span className="notification-item__time">{getRelativeTime(notif.time)}</span>
                </div>
              </div>
            )
          })}
        </div>
      )}

      <div className="notification-panel__footer">
        <Button
          type="link"
          size="small"
          style={{ color: '#13AED8', fontSize: 13 }}
        >
          Voir toutes les notifications
        </Button>
      </div>
    </div>
  )

  return (
    <Dropdown
      overlay={panelContent}
      trigger={['click']}
      placement="bottomRight"
    >
      <button className="bell-trigger" aria-label="Notifications">
        <Badge count={unreadCount} size="small" offset={[-2, 2]}>
          <BellOutlined style={{ fontSize: 18 }} />
        </Badge>
      </button>
    </Dropdown>
  )
}

export default NotificationBell
